import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blg-dual-column-form',
  templateUrl: './dual-column-form.component.html',
  styleUrls: ['./dual-column-form.component.scss']
})
export class DualColumnFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
